import {
  WSButton,
  WSCard,
  WSElement,
  WSImage,
  WSInfoBox,
  WSList,
  WSMessageBox,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { openInNewTab } from "../../../../utils/openInNewTab";
import { Benefit } from "../../data";
import { selectorBenefitCostLabel } from "../../selectors/selectorBenefitCostLabel";
import { insertMemberIds } from "../../utils/insertMemberIds";
import styles from "./index.module.scss";

type Props = {
  benefit: Benefit;
  memberNumber: string;
  groupNumber: string;
  showCtaAndContactInfo: boolean;
  showMemberAndGroupInfo: boolean;
};

const contactInstruction = (benefit: Benefit) => {
  if (benefit.sidebarContactPhone && benefit.sidebarContactEmail) {
    return "Call or email";
  }
  return benefit.sidebarContactEmail ? "Email" : "Call";
};

export const BenefitDetailSidebar: React.FC<Props> = props => {
  const { benefit } = props;

  const ctaLink = benefit.sidebarCtaLink;

  return (
    <WSCard>
      <WSList gap="XL">
        {benefit.sidebarHeader && (
          <WSElement className={styles.sidebarHeaderContainer} p="S">
            <WSText align="center" color="gray600">
              {benefit.sidebarHeader}
            </WSText>
          </WSElement>
        )}

        {benefit.sidebarLogoUrl && (
          <WSImage
            src={benefit.sidebarLogoUrl}
            placeholder={benefit.sidebarLogoPlaceholder}
          />
        )}

        {!benefit.hideCost && (
          <WSInfoBox theme="neutral">
            Cost: {selectorBenefitCostLabel(benefit)}
          </WSInfoBox>
        )}

        {benefit.sidebarUsageText && (
          <WSText>
            {insertMemberIds({
              text: benefit.sidebarUsageText,
              memberNumber: props.showMemberAndGroupInfo
                ? props.memberNumber
                : undefined,
              groupNumber: props.showMemberAndGroupInfo
                ? props.groupNumber
                : undefined
            })}
          </WSText>
        )}

        {props.showCtaAndContactInfo && (
          <>
            {benefit.sidebarCtaCustom ||
              (benefit.sidebarCtaText && ctaLink ? (
                <WSButton fullWidth onClick={() => openInNewTab(ctaLink)}>
                  {benefit.sidebarCtaText}
                </WSButton>
              ) : null)}

            {benefit.sidebarContactDescription && (
              <WSText>{benefit.sidebarContactDescription}</WSText>
            )}

            {(benefit.sidebarContactEmail || benefit.sidebarContactPhone) && (
              <WSMessageBox kind="Regular" noBorder>
                <WSText mb="XS">{contactInstruction(benefit)}</WSText>
                {benefit.sidebarContactPhone && (
                  <WSText.Heading4
                    onClick={() =>
                      openInNewTab(
                        `tel:${benefit.sidebarContactPhone!.replace(/\D/g, "")}`
                      )
                    }
                    mb={benefit.sidebarContactEmail ? "XS" : "NONE"}
                  >
                    {benefit.sidebarContactPhone}
                  </WSText.Heading4>
                )}
                {benefit.sidebarContactEmail && (
                  <WSButton.Link
                    onClick={() =>
                      window.open(`mailto:${benefit.sidebarContactEmail}`)
                    }
                  >
                    {benefit.sidebarContactEmail}
                  </WSButton.Link>
                )}
              </WSMessageBox>
            )}
          </>
        )}

        {props.showMemberAndGroupInfo && (
          <WSElement>
            <WSText.ParagraphSm color="gray500">
              Your Member ID
            </WSText.ParagraphSm>
            <WSText mt="XS">{props.memberNumber}</WSText>
            <WSText.ParagraphSm color="gray500" mt="XL">
              Your Group ID
            </WSText.ParagraphSm>
            <WSText mt="XS">{props.groupNumber}</WSText>
          </WSElement>
        )}
      </WSList>
    </WSCard>
  );
};
